import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useLocales } from 'react-localized';
var CompHook = function () {
    var gettext = useLocales().gettext;
    return (_jsx(_Fragment, { children: _jsx("p", { children: gettext('Hello, World!') }) }));
};
export default CompHook;
